import { Dispatch, ExtraArgs, GetState } from '../../types'
import { SelectorAction } from '../redux/selector/model'
import { Environment } from '../../remote-api/models'
import { fetchLoaderHelper } from '../redux/loader/thunksFor'
import { selectResourceFromResources } from '../redux/selector/thunksFor'
import selectorActionCreatorsFor from '../redux/selector/actionCreatorsFor'
import { ENVIRONMENT_PREFIX, ENVIRONMENT_RESOURCE_NAME } from './model'
import { selectors as authSelectors } from '../../lifecycle/auth';
import { SelectorOptions } from '../selector/model'

export type EnvironmentAction =
  | SelectorAction<Environment>

// Basic Actions Creators

export const environmentActionCreators = (origin?: string) => {
  return {
    ...selectorActionCreatorsFor<Environment>(ENVIRONMENT_RESOURCE_NAME, ENVIRONMENT_PREFIX, origin)
  }
}

// Thunks

export const fetchEnvironments = (origin?: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs): Promise<Environment[]> => {
  return fetchLoaderHelper<Environment[]>(dispatch, environmentActionCreators(origin), async () => {
    return api.cs(getState)
      .fetchEnvironments(getState().monitoring.auth.profile.organizationId)
      .then(response => response.data)
  })
}

export const selectEnvironmentForEnvironments = (options: SelectorOptions, environments: Environment[], envId?: string) =>
  (dispatch: Dispatch, getState: GetState): Environment | undefined => {
    const actionCreators = environmentActionCreators(options.origin)
    const preferredEnvId = authSelectors.getPreferredEnvironment(getState(), getState().monitoring.auth.profile.organizationId)

    return dispatch(selectResourceFromResources<Environment>(
      ENVIRONMENT_RESOURCE_NAME,
      environments,
      (environment: Environment) => environment.id,
      actionCreators.resourceSelected,
      options.origin,
      options.lsOrigin,
      envId,
      preferredEnvId
    ))
  }

export const storeEnvironmentsAndSelectOne =
  (environment: Environment, environments: Environment[], origin?: string) =>
    (dispatch: Dispatch) => {
      const actionCreators = environmentActionCreators(origin)
      dispatch(actionCreators.fetchSuccess(environments))
      dispatch(actionCreators.resourceSelected(environment))
    }
